import {
  saveSelectedItemsAction,
  saveScrollPositionAction,
} from './actions';

/**
 * 選択データを保存
 *
 * @param {string} screenId 画面Id
 * @param {array} compareKey
 *                  一覧のデータと保存した選択データを比較して同じ行か判別するためのキー
 * @param {array} selectedItems 選択データ
 * @return {void}
 */
const doSaveSelectedItems = (
    screenId, compareKey, selectedItems) => {
  return async (dispatch) => {
    dispatch(saveSelectedItemsAction(
        screenId, compareKey, selectedItems));
  };
};

/**
 * グリッドのスクロール位置を保存
 *
 * @param {string} screenId 画面Id
 * @param {array} scrollPosition スクロール位置
 * @return {void}
 */
const doSaveScrollPosition = (screenId, scrollPosition) => {
  return async (dispatch) => {
    dispatch(saveScrollPositionAction(screenId, scrollPosition));
  };
};

export default {
  doSaveSelectedItems,
  doSaveScrollPosition,
};
